import React, { useEffect } from "react";
import Modal from "react-modal";
import CustomButton from "../CustomButton";

const CustomModal = (props) => {
  useEffect(() => {
    if (props.open) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [props.open]);

  return (
    <Modal
      isOpen={props.open}
      onRequestClose={props.closeHandler}
      style={{
        content: {
          backgroundColor: props.yellow ? "var(--hubbleMenuItem)" :  "var(--primary500)",
          color: "var(--appAccentColor)",
          maxWidth: "400px",
          borderRadius: "24px",
          height: "fit-content",
          maxHeight: "90vh",
          overflow: "auto",
          margin: "auto",
          padding: "32px",
          zIndex: 9999,
          border: "none",
          animation: "fadeIn 0.6s ease-in-out",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 70%)",
          zIndex: 9998,
          paddingBlock: "32px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      }}
    >
      <div className="text-center w-100">
        {props.dialogContent && props.dialogContent}
        {!props.inputDialog && (
          <CustomButton
            text={"بستن"}
            clickHandler={props.closeHandler}
            color={"primary"}
            shadow={true}
          />
        )}
      </div>
    </Modal>
  );
};

export default CustomModal;
